import Cookies from '@comeon/tomcat-cookies';

export const SYNC_COOKIES = '@komigen/mobile-frontend/store/cookies/SYNC_COOKIES';

export function syncCookies() {
	return dispatch =>
		dispatch({
			type: SYNC_COOKIES
		});
}

function reducer(state = { ...Cookies.get() }, { type }) {
	switch (type) {
		case SYNC_COOKIES:
			return { ...Cookies.get() };
		default:
			return state;
	}
}

export default reducer;
